/**
 * 接口域名的管理
 * 参数在根目录对应的.env文件
 * 开发环境 .env.development => http://localhost:3000
 * 测试环境 .env.test => http://8.142.139.164:8859
 * 预生产环境 .env.pre
 * 生产环境 .env.production
 */
const env = import.meta.env;
export interface BaseUrl {
  cs: string;
  ac: string;
  jxc: string;
  financeApi1: string;
  financeApi2: string;
  budgetCloud: string;
  qy: string;
  signalr: string;
  nocode: string;
  al: string;
  cw: string;
}
export const baseUrl: BaseUrl = {
  cs: env.VITE_APP_API,
  ac: env.VITE_APP_API_AC,
  jxc: env.VITE_APP_API_JXC,
  financeApi1: env.VITE_APP_API_FINANCE1,
  financeApi2: env.VITE_APP_API_FINANCE2,
  budgetCloud: env.VITE_APP_API_BUDGET,
  qy: env.VITE_APP_API_QY,
  signalr: env.VITE_APP_SIGNALR,
  nocode: env.VITE_APP_NOCODE_API,
  al: env.VITE_APP_AL_BASE_URL,
  cw: env.VITE_APP_CW_BASE_URL,
};
if (import.meta.env.DEV) console.log(env);
